import React from "react";
import { OtherTreatmentsScreen } from "./OtherTreatmentsScreen";

export function TimedIntercourseTreatmentsScreen() {
  return <OtherTreatmentsScreen mode="timed_intercourse" />;
}

export default TimedIntercourseTreatmentsScreen;
